import Skeleton from '@carvana/ds-skeleton';

export default function FinanceLoadingCard() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading financing"
      aria-live="polite"
      className="min-h-[202px] rounded-md border border-border-weak bg-background-default p-2xl"
      data-testid="finance-loading-card"
      role="status"
    >
      <div className="flex h-full flex-col justify-between gap-xl">
        {/* Header: Title and Badge */}
        <div className="flex items-start justify-between">
          <Skeleton height={26} width={140} />
          <Skeleton height={26} width={100} />
        </div>

        <div className="flex gap-lg">
          {/* Circle badge */}
          <Skeleton
            height={70}
            width={70}
            className="mx-[15px] shrink-0 rounded-full"
          />

          {/* Text content */}
          <div className="flex w-full flex-col gap-md">
            <Skeleton height={18} width="80%" />
            <Skeleton height={18} width="95%" />
            <Skeleton height={18} width="50%" />
          </div>
        </div>

        {/* Button */}
        <Skeleton height={40} width="100%" className="rounded-full" />
      </div>
    </div>
  );
}
